import { render } from "./request-and-load.vue?vue&type=template&id=c374848c"
import script from "./request-and-load.vue?vue&type=script&lang=js"
export * from "./request-and-load.vue?vue&type=script&lang=js"
script.render = render

export default script